<script>
import axios from 'axios';
import AS from '@/services/AuthenticationService';

export default {
  /**
   * Busca dados do protocolo REDESIM para pré-preenchimento de requerimento
   * @param {string} protocolo - Número do protocolo REDESIM (ex: AL2024XXXXX)
   * @returns {Promise} - Dados do protocolo com pessoa e endereço
   */
  fetchByProtocolo(protocolo) {
    return axios.get(`redesim_protocolos/${protocolo}`, AS.getDefaultHeaders());
  },
};
</script>
